/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntityIdListResponse } from '../../models/entity-id-list-response';

export interface GetAssociationsByTag$Params {
  'Active-Tenant-Identifier': string;
  id: string;
}

export function getAssociationsByTag(http: HttpClient, rootUrl: string, params: GetAssociationsByTag$Params, context?: HttpContext): Observable<StrictHttpResponse<EntityIdListResponse>> {
  const rb = new RequestBuilder(rootUrl, getAssociationsByTag.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EntityIdListResponse>;
    })
  );
}

getAssociationsByTag.PATH = '/associations/tag/{id}';
